/**
 * The model's own prose, tidied before anyone reads it.
 *
 * The judge writes the "why" on every cut and the reasoning panel, and it
 * reaches an HR director as the product's own words. It likes an em dash, and
 * an em dash is the clearest tell that a machine wrote something.
 *
 * The prompt now asks it not to. This is the other half, because it covers
 * every answer already saved and every time the model forgets. A comma does
 * the same work.
 */
export const plain = (text: string): string =>
  text
    .replace(/\s*[\u2014\u2013]\s*/g, ', ')
    .replace(/,\s*,/g, ',')
    .replace(/\s+([.,;:])/g, '$1')
